import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppTab } from '../core/app-tab';
import { ShowRequest } from '../core/show-request';
import { AppState, TestbedServerClientStats } from '../core';
import { Subscription } from 'rxjs';
import { EventLogTableComponent } from './event-log-table.component';

//
// For admin users to see mobile and testbed client activity
//
@Component({
  selector: 'app-event-log',
  templateUrl: './event-log.component.html'
})
export class EventLogComponent implements OnInit, OnDestroy {

  @Input() tabConfig: AppTab;

  @Input() detailFn: (vi: ShowRequest) => void;

  @Input() isActiveView: boolean

  @Input() contextJson: string;

  @Input() contextJsonChangeHandler : (itemId: string,tab:AppTab) => void

  @ViewChild('eventLogTable') eventLogTable: EventLogTableComponent;
  clientStats: TestbedServerClientStats;
  clientStatusSub?: Subscription;

  constructor(public appState: AppState) {
    this.clientStats = this.appState.clientStats$.value;
  }

  ngOnInit(): void {
    this.clientStatusSub = this.appState.clientStats$.subscribe( clientStats => {
      this.clientStats = clientStats;
      this.eventLogTable?.load().catch(err => this.appState.publishError(err) );
    })
  }

  ngOnDestroy(): void {
    this.clientStatusSub?.unsubscribe();
  }
}
